import {MermaidRenderer} from '@github-ui/copilot-markdown/extensions/Mermaid'
import {useState} from 'react'

import {usePreviewUrl} from '../../contexts/PreviewUrlContext'
import styles from './MermaidPreview.module.css'

interface MermaidPreviewProps {
  code: string
  isStreaming?: boolean
}

export function MermaidPreview({code, isStreaming}: MermaidPreviewProps) {
  const previewUrl = usePreviewUrl()
  const [identity] = useState(() => `mermaid-preview-${Math.random().toString(36).slice(2, 11)}`)

  if (!previewUrl) return null

  return (
    <div className={styles.container}>
      <MermaidRenderer code={code} identity={identity} viewscreenHost={previewUrl} isStreaming={isStreaming} />
    </div>
  )
}
